import { Observable } from 'rxjs'
import { MbReview } from '../../../models'

export abstract class MbProductReviewsAdapter {

  abstract load(productCode: string, maxCount?: number): Observable<MbReview>
}
